import { loadStripe } from '@stripe/stripe-js'

const publishableKey = import.meta.env.VITE_STRIPE_PUBLISHABLE_KEY as
  | string
  | undefined

if (!publishableKey && import.meta.env.PROD) {
  throw new Error('VITE_STRIPE_PUBLISHABLE_KEY is not set')
}

export const stripePromise = publishableKey ? loadStripe(publishableKey) : null
